
function LoadTextToSpeech() {
    const textarea = document.getElementById("txtArea"),
        voiceList = document.getElementById("drpVoice"),
        speechBtn = document.getElementById("btnTextSpeech");

    let synth = speechSynthesis,
        isSpeaking = true;

    voices();
    synth.addEventListener("voiceschanged", voices);

    speechBtn.addEventListener("click", e => {
        e.preventDefault();
        if (textarea.value.trim() !== "") {
            if (!synth.speaking) {
                textToSpeech(textarea.value);
            }
            if (textarea.value.length > 80) {
                setInterval(() => {
                    if (!synth.speaking && !isSpeaking) {
                        isSpeaking = true;
                        speechBtn.innerText = "Convert To Speech";
                        textarea.disabled = false;
                    } else {
                    }
                }, 500);
                if (isSpeaking) {
                    synth.resume();
                    isSpeaking = false;
                    speechBtn.innerText = "Pause Speech";
                    textarea.disabled = true;
                } else {
                    synth.pause();
                    isSpeaking = true;
                    speechBtn.innerText = "Resume Speech";
                    textarea.disabled = true;
                }
            } else {
                speechBtn.innerText = "Convert To Speech";
                textarea.disabled = false;
            }
        }
    });

    function voices() {
        for (let voice of synth.getVoices()) {
            let selected = voice.name === "Google US English" ? "selected" : "";
            let option = `<option value="${voice.name}" ${selected}>${voice.name} (${voice.lang})</option>`;
            voiceList.insertAdjacentHTML("beforeend", option);
        }
    }


    function textToSpeech(text) {
        let utterance = new SpeechSynthesisUtterance(text);
        for (let voice of synth.getVoices()) {
            if (voice.name === voiceList.value) {
                utterance.voice = voice;
            }
        }
        synth.speak(utterance);
    }

}
